<template>
    <button id="FullscreenButton" v-if="!onHomePage" :class="{'FullscreenButton--isFullscreen': isFullscreen}" @click="toggleFullscreen" aria-hidden="true">
        <img src="@/assets/img/ui/fullscreen.svg" v-if="!isFullscreen">
        <img src="@/assets/img/ui/fullscreen-active.svg" v-else>
    </button>
</template>
<script>
export default {
    props: ["onHomePage"],
    methods: {
        toggleFullscreen() {
            app.api.Utils.toggleFullscreen();
        }
    },
    computed: {
        isFullscreen() {
            return this.$store.getters.isFullscreen
        }
    }
}
</script>
<style lang="scss" scoped>
    #FullscreenButton {
        position: absolute;
        left: 170px;

        img {
            width: 24px;
        }
    }
</style>